/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_EmptyInputs */

const cs_tasks_empty = /** @type {(inputs: Tasks_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné úkoly.`)
};

const en_tasks_empty = /** @type {(inputs: Tasks_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tasks.`)
};

/**
* | output |
* | --- |
* | "No tasks." |
*
* @param {Tasks_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_empty = /** @type {((inputs?: Tasks_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_empty(inputs)
	return cs_tasks_empty(inputs)
});